// extracted by mini-css-extract-plugin
export var bottomCircle = "bB_g0";
export var content = "bB_b8";
export var description = "bB_dx";
export var hide = "bB_B";
export var icon = "bB_bq";
export var image = "bB_g";
export var imageContainer = "bB_g4";
export var left = "bB_bT";
export var nextYear = "bB_g3";
export var right = "bB_cv";
export var section = "bB_d";
export var shrink = "bB_g2";
export var title = "bB_h";
export var topCircle = "bB_gZ";
export var wave = "bB_f8";
export var waveContainer = "bB_d7";
export var year = "bB_g1";